export const networkThemesFeedBasePath = `/network-themes`;
export const networkThemesFeedMatchPath: string = `${networkThemesFeedBasePath}/:themeId`;

type NetworkThemeFeedPage = (themeId: string) => string;
export const networkThemeFeedPage: NetworkThemeFeedPage = (themeId) => `${networkThemesFeedBasePath}/${themeId}`;
